import {ExpertSystemEquipmentType} from '@domain/expert-system'
import {Toggle, ToggleConfig} from '@hconnect/common/components'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

export const EQUIPMENT_TYPE_CONFIG: ToggleConfig<ExpertSystemEquipmentType> = [
  {
    type: ExpertSystemEquipmentType.Kiln,
    labelKey: 'label.kilns',
    dataTestId: 'equipment-type-toggle-btn-kiln'
  },
  {
    type: ExpertSystemEquipmentType.Mill,
    labelKey: 'label.mills',
    dataTestId: 'equipment-type-toggle-btn-mill'
  }
]

type EquipmentTypeToggleProps = {
  value: ExpertSystemEquipmentType
  onChange: (value: ExpertSystemEquipmentType) => void
  fullWidth?: boolean
  inverted?: boolean
}

export const EquipmentTypeToggle: React.FC<EquipmentTypeToggleProps> = ({inverted, ...props}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Toggle<ExpertSystemEquipmentType>
      config={EQUIPMENT_TYPE_CONFIG}
      t={t}
      isContrastMode={inverted}
      {...props}
    />
  )
}
